import * as React from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  Box,
  CssBaseline,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
  Group as GroupIcon,
  MenuBook as ChapterIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Logout as LogoutIcon,
} from "@mui/icons-material";
// import LogsPopup from "../pages/Logs/LogsPopup";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Drawer, DrawerHeader } from "./Themecomponent";

export default function Layout() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const isXS = useMediaQuery(theme.breakpoints.only("xs"));
  const isSM = useMediaQuery(theme.breakpoints.only("sm"));
  const isMD = useMediaQuery(theme.breakpoints.only("md"));
  const isLG = useMediaQuery(theme.breakpoints.only("lg"));
  const isXL = useMediaQuery(theme.breakpoints.only("xl"));

  const [open, setOpen] = React.useState(isSM ? false : true);
  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  React.useEffect(() => {
    setOpen(isXS ? false : true);
  }, [isSM]);
  const locations = window.location.pathname.split("/");

  const isUserRoute = locations.includes("user");
  const handleLogout = () => {
    if (isUserRoute) {
      localStorage.removeItem("usersAccess");
      localStorage.removeItem("usersId");
    } else {
      localStorage.removeItem("token");
    }
    navigate(isUserRoute ? "/user/login/" : "/login");
  };
  const menuItems = [
    {
      text: "Dashboard",
      icon: <DashboardIcon />,
      path: isUserRoute ? "/user" : "/",
    },
    !isUserRoute && {
      text: "Users",
      icon: <GroupIcon />,
      path: "/users",
    },
    {
      text: "Chapter",
      icon: <ChapterIcon />,
      path: isUserRoute ? "/user/chapter" : "/chapter",
    },
  ].filter(Boolean); // removes false entries

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <Drawer variant="permanent" open={open} sx={{ background: "#F7FAFF" }}>
        <DrawerHeader
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            display: "flex",
            background: "#F7FAFF",
          }}
        >
          <Box
            sx={{
              display: open ? "flex" : "none",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <img
              src="/logo/Artboard 4 1.png"
              width={100}
              alt="Logo"
              loading="lazy"
            />
          </Box>
          <IconButton onClick={open ? handleDrawerClose : handleDrawerOpen}>
            {open ? (
              theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )
            ) : theme.direction === "rtl" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </DrawerHeader>

        <Divider />

        <List sx={{ background: "#F7FAFF" }}>
          {menuItems.map((item) => (
            <ListItem key={item.text} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  px: 2.5,
                  backgroundColor:
                    location.pathname === item.path
                      ? theme.palette.primary.main
                      : "inherit",
                  color: location.pathname === item.path ? "white" : "inherit",
                  "&:hover": {
                    color: "#fff",
                    backgroundColor: theme.palette.primary.main,
                  },
                  justifyContent: open ? "initial" : "center",
                }}
                onClick={() => {
                  navigate(item.path);
                  handleDrawerClose();
                }}
              >
                <Tooltip title={item.text} placement="right" arrow>
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      justifyContent: "center",
                      color:
                        location.pathname === item.path ? "white" : "inherit",
                      mr: open ? 3 : "auto",
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                </Tooltip>
                <ListItemText
                  primary={item.text}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Divider />

        <List sx={{ marginTop: "auto", background: "#F7FAFF" }}>
          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              onClick={handleLogout}
              sx={{
                minHeight: 48,
                px: 2.5,
                color: "#000",
                "&:hover": {
                  color: "#fff",
                  backgroundColor: theme.palette.primary.main,
                },
                justifyContent: open ? "initial" : "center",
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  justifyContent: "center",
                  mr: open ? 3 : "auto",
                }}
              >
                <Tooltip title="Logout" placement="right">
                  <LogoutIcon />
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary="Logout" sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>

      <Box
        sx={{
          background: "#fff",
          flexGrow: 1,
          p: isXS ? 1 : isSM ? 2 : isMD ? 3 : isLG ? 4 : 5,
          width:
            isXS || isSM || isMD || isLG || isXL
              ? `calc(${open ? "80%" : "100%"} - 65px)`
              : "auto",
          height: "100%",
          minHeight: "calc(100vh - 100px)",
        }}
      >
        <Outlet />
      </Box>

      {/* <LogsPopup /> */}
    </Box>
  );
}
